import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../Theming';
import Header from './Components/Header';
import { eonImages } from '../Theming/images';
import { usePageViewTracking } from '../Common/Hooks';
import { ANALYTICS_PAGE_NAMES } from '../Common/Analytics/utils';

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 30px;
`;

const Title = styled.div`
  padding-top: 15px;
`;

const TitleText = styled.p<{ $fontSize?: string }>`
  color: ${themeColor('white')};
  font-family: Helvetica;
  text-align: center;
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '24px')};
  margin: 0;
  padding-inline: 10vw;
  line-height: 1.3;

  &:first-child {
    font-weight: 700;
    font-family: Helvetica-Bold;
  }
`;

const InfoContainer = styled.div`
  padding-top: 5vh;
`;

const InfoTitle = styled.h3`
  text-align: center;
  font-weight: 700;
  font-family: Helvetica;
  margin: 20px 0 10px 0;
`;

const ActivationStepsContainer = styled.div<{ $fontSize?: string }>`
  flex-direction: row;
  display: flex;
  height: 300px;
  justify-content: center;
  width: 100%;
  padding-inline: 10vw;

  & > img {
    height: 100%;
  }

  & > ol {
    padding: 0 0 0 10px;
    margin: 0;
    list-style-type: none;
    color: ${themeColor('navyBlueText')};
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '16px')};
    font-weight: 400;
    display: flex;
    flex-direction: column;
    font-family: Helvetica;
    justify-content: space-between;
  }
`;

const ListItem = styled.li<{ $index?: number }>`
  line-height: 1.5;
  font-family: Helvetica;
  font-weight: 700;
  height: calc(310px / 5);

  display: flex;
  align-items: center;

  :not(:last-child) {
    margin-bottom: 20px;
  }
`;

interface Props {
  sliide?: boolean;
}

const EonPluginActivationPartialPermissions: React.FC<Props> = () => {
  const { t } = useTranslation();
  const infoItem = [
    'goToSettings',
    'tapSafari',
    'scrollDownToExtensions',
    'selectEonNext',
    'allowBothWebsites',
  ];
  const { partially_installed_page } = ANALYTICS_PAGE_NAMES;
  const { eon_header_generic, safari_settings_partial } = eonImages;
  usePageViewTracking(partially_installed_page, 'Eon');

  return (
    <Container>
      <Header
        height="230px"
        image={eon_header_generic}
        titleContent={
          <Title>
            <Trans t={t} i18nKey="eon.notActive">
              <TitleText
                $fontSize={window.screen.width > 380 ? '35px' : '30px'}
              />
              <TitleText $fontSize="18px" />
            </Trans>
          </Title>
        }
      />
      <InfoContainer>
        <InfoTitle>{t('eon.followTheseSteps')}</InfoTitle>
        <ActivationStepsContainer
          $fontSize={window.screen.width > 380 ? '16px' : '15px'}
        >
          <img
            src={safari_settings_partial}
            alt="safari activation settings steps"
          />
          <ol>
            {infoItem.map((item, index) => (
              <ListItem $index={index} key={index}>
                {t(`eon.${item}`)}
              </ListItem>
            ))}
          </ol>
        </ActivationStepsContainer>
      </InfoContainer>
    </Container>
  );
};

export default EonPluginActivationPartialPermissions;
